import React from 'react';
import s from './Button.scss';
import LoadingGif from '../../../assets/images/loading.svg';

const Button = ({ onClick, style, children, className = '', isLoading, disabled = false, id, userId, fieldId, entryId, name, collateral, value, pyme }) => {

    return (
        <button onClick={onClick} value={value} disabled={disabled} style={style} name={name} className={`${s.button} ${className}`}
        id={id} data-user={userId} data-entry={entryId} data-field={fieldId} data-collateral={collateral} data-pyme={pyme}>
            {isLoading ? <img className={s.img} src={LoadingGif} alt={"cargando..."} /> : children}
        </button>
    )
};

export default Button;
